import { apiClient } from "@/lib/api-client";
import type { Account } from "@/features/auth/types";
import type {
  ChangePasswordRequest,
  DeleteAccountRequest,
  UpdateEmailRequest,
} from "@/features/account/types";

export const accountApi = {
  me: () => apiClient.get<Account>("/v1/accounts/me"),
  updateEmail: (req: UpdateEmailRequest) => apiClient.put<Account>("/v1/accounts/me/email", req),
  changePassword: (req: ChangePasswordRequest) =>
    apiClient.put<void>("/v1/accounts/me/password", req),
  deleteAccount: (req: DeleteAccountRequest) => apiClient.delete("/v1/accounts/me", req),
};
